import { authStore } from '@/core/auth/auth-store';

import type { ApiError } from './api-error';

export function handleAuthError(err: ApiError, navigate: (path: string) => void): void {
  const currentUrl = typeof globalThis.window === 'undefined'
    ? '/'
    : globalThis.location.pathname + globalThis.location.search;
  const onLanding = currentUrl === '/' || currentUrl.startsWith('/?');
  const onUnauthorized = currentUrl.startsWith('/unauthorized');

  if (err.status === 401 && !onLanding) {
    authStore.getState().clearUser();
    navigate(`/?returnUrl=${encodeURIComponent(currentUrl)}`);
    return;
  }

  if (err.status === 403 && !onUnauthorized) {
    navigate(`/unauthorized?returnUrl=${encodeURIComponent(currentUrl)}`);
  }
}
